export const countryCheck = (country) => {
  switch (country){
    case "UK":
      return "GB"
    default:
      return country
  }
}
